import { Link } from "react-router-dom";
import { Cookie } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";
import { setConsent, useConsent } from "@/lib/consent";

export function CookieBanner() {
  const consent = useConsent();
  if (consent) return null;
  return (
    <div role="dialog" aria-label="Cookie consent" className="fixed inset-x-3 bottom-3 sm:left-6 sm:right-auto sm:bottom-6 sm:max-w-md z-[60] glass p-5 shadow-xl fade-up" data-testid="cookie-banner">
      <p className="text-sm font-medium flex items-center gap-2"><Cookie size={18} className="text-amber-600" />We use cookies</p>
      <p className="text-xs text-muted-foreground mt-2 leading-relaxed">Essential cookies keep you signed in. Ads from Google AdSense keep this site free; with your OK they can use cookies to personalize and measure ads. Choose "Essential only" to see non-personalized ads instead. See our <Link to="/cookies" className="underline" data-testid="cookie-banner-policy-link">Cookie Policy</Link>.</p>
      <div className="flex gap-2 mt-4 justify-end">
        <Button variant="outline" size="sm" className="rounded-full" onClick={() => setConsent("rejected")} data-testid="cookie-reject-button">Essential only</Button>
        <Button size="sm" className="rounded-full" onClick={() => setConsent("accepted")} data-testid="cookie-accept-button">Accept all</Button>
      </div>
    </div>
  );
}
